// Copyright (c) 2015 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import React, { Component } from 'react'
import { connect } from 'react-redux';
import DeckGL, {MapController} from 'deck.gl';
import MapGL, {NavigationControl } from 'react-map-gl';
import GL from '@luma.gl/constants';
import {GeoJsonLayer, PolygonLayer} from '@deck.gl/layers';
import {SimpleMeshLayer,} from '@deck.gl/mesh-layers';
import {FlyToInterpolator } from '@deck.gl/core';
import {registerLoaders} from '@loaders.gl/core';
import {GLTFScenegraphLoader} from '@luma.gl/addons';
import {IcoSphereGeometry} from 'luma.gl';
import {isWebGL2} from '@luma.gl/core';
import styled from 'styled-components';
import * as d3 from 'd3';
import _ from 'lodash';
import Tree from 'react-tree-graph';
import Select from 'react-select';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';

// Register the proper loader for scenegraph.gltf
registerLoaders([GLTFScenegraphLoader]);

const sphere = new IcoSphereGeometry({
  iterations: 1
});

const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGhhbHBlcm4iLCJhIjoiY2p3MHFvZHg2MDcyczQ4bXBjNW85aDh2OCJ9.OUluk6vAGe5BVXLOiGIoQQ';
const mapStyle = 'mapbox://styles/dhalpern/ck9j43zz40fcc1ippl93betya?fresh=true';

const WEBGL_PARAMETERS = {
  // prevent flicker from z-fighting
  [GL.DEPTH_TEST]: false,

  // turn on additive blending to make them look more glowy
  [GL.BLEND]: true,
  [GL.BLEND_SRC_RGB]: GL.ONE,
  [GL.BLEND_DST_RGB]: GL.ONE,
  // [GL.BLEND_EQUATION_RGB]: GL.FUNC_ADD,
  [GL.BLEND_EQUATION_ALPHA]: GL.FUNC_ADD,
};

const VizContainer = styled.div`
  // position:absolute;
  width:100vw;
  position:relative;
  z-index:1;
  // top:110%;
  // left:0;
`;

const MapContainer = styled.div`
  height:80vh;
  width:100vw;
  position:relative;
  box-shadow:0px 0px 5px rgba(0,0,0,0.5);
`;

const forceHeight  = () => {  
  
  return window.innerHeight*0.6
}

const forceWidth = () => {
  let tempScale;

  if (window.innerWidth > 1440) {
    tempScale = 0.4;
  } else if (window.innerWidth > 768) {
    tempScale = 0.75;
  } else {
    tempScale = 0.95;
  }

  return window.innerWidth*tempScale
} 

const RightCol = styled.div`
  position:absolute;
  right:20px;
  top:20px;
  height:60vh;
  width:40vw;
  @media (max-width:1440px) {
    width:75vw;
    height:75vh;
    z-index:120;
  }
  @media (max-width:768px){
    width:95vw;
  }
  background:rgba(0,0,0,0);
  button.networkButton {
    border:none;
    position:absolute;
    top:0;
    right:20px;
    background:rgb(61,61,61);
    z-index:500;
    color:white;
    transition:250ms all;
  }
}
  
`;
const SpeciesForce = styled.div`
  transition:250ms all;
  padding: 20px;
  background: rgb(61, 61, 61);
  box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
  0 2px 2px rgba(0,0,0,0.12), 
  0 4px 4px rgba(0,0,0,0.12), 
  0 8px 8px rgba(0,0,0,0.12),
  0 16px 16px rgba(0,0,0,0.12);
  p {
    font-weight:bold;
    color:white;
    text-align:center;
  }
  svg path {
    fill:none;
    stroke:white;
    stroke-width:1px;
  }
  svg {
    overflow: visible;
  }
  svg g circle {
    fill:white;
    display:none;
  }
  svg g text {
    font-family:'Roboto', sans-serif;
    font-size:10px;
    paint-order: stroke;
    stroke: rgb(61, 61, 61);
    stroke-width: 5px;
    stroke-linecap: butt;
    stroke-linejoin: miter;
    font-weight: 800;
    fill:white;
    transform:translateX(-15px);

  }
`
const CityInfo = styled.div`
    padding:40px 20%;
    box-sizing:border-box;
    width:100vw;
    font-family: 'Averia Serif Libre', serif !important;
    h1,h2,h4,h5 {
      color:white;
      font-size:2vw;
      line-height:1.1;
      transition:250ms opacity;
      transition-delay:250ms opacity;
    }
    div.no-interact {
      pointer-events:none;
      user-select: none;
    }
    h2 {
      font-weight:700;
      letter-spacing:-1px;
      pointer-events:none;
    }

    h4, h5 {
      color:#a5fea7;
      font-weight:700;
      font-size:1.5rem;
      margin-bottom:0;
      pointer-events:none;
    }
    h4.fadeOut {
      opacity:0;
      transition-delay:0ms opacity;
    }

    h4 {
      margin-top:1rem;
    }

    h5 {
      line-height:1.1;
      opacity:0.5;
    }
    h5 i {
      font-style:italic;
      margin-bottom:0.5rem;
    }
`
const LegendBox = styled.div`
  position:absolute;
  bottom:20px;
  left:50%;
  transform:translateX(-50%);
  background:#525252;
  color:white;
  padding:15px;
  font-family:'Open Sans', sans-serif;  
  box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
  0 2px 2px rgba(0,0,0,0.12), 
  0 4px 4px rgba(0,0,0,0.12), 
  0 8px 8px rgba(0,0,0,0.12),
  0 16px 16px rgba(0,0,0,0.12);
  h1 {
    text-align:center;
    display:block;
    margin-bottom:15px;
    font-family:'Open Sans', sans-serif;
    font-weight:bold;
  }
  div {
    background:red;
    height:15px;
    width:12.5%
    stroke:1px solid white;
    display:inline-block;
  }
  p {
    width:20%;
    text-align:center;
    color:white;
    display:inline-block;
    font-family:'Open Sans', sans-serif;
  }
  p:nth-of-type(1), 
  p:nth-of-type(2) {
    text-align:left;
  }
  
  p:nth-of-type(5),p:nth-of-type(4) {
    text-align:right;
  }
  h2{
    width:50%;
    display:inline-block;
    font-weight:bold;
    margin-top:15px;
  }
  h2:nth-of-type(1) {
    text-align:left;
  }
  h2:nth-of-type(2) {
    text-align:right;
  }
  @media (max-width:600px){
    width:75vw;
  }
`
const TreeBlocksButtonContainer = styled(ButtonGroup)`
  position:absolute;
  z-index:100;
  top:20px;
  left:20px;
  }
`
const TreeBlocksButton = styled(Button)`
  background:white;
  color:black;
`
const DATA_URL = {
  BOLOGNA:
    `${process.env.PUBLIC_URL}/data/BolClean.json`, // eslint-disable-line
  BOLOGNA_CENTER:
    `${process.env.PUBLIC_URL}/data/BolCenter.geojson`, // eslint-disable-line
  BOLOGNA_TREES:
    `${process.env.PUBLIC_URL}/data/BolTrees.json`, // eslint-disable-line
  AMSTERDAM:
  `${process.env.PUBLIC_URL}/data/AmsClean.json`, // eslint-disable-line
  AMSTERDAM_CENTER:
    `${process.env.PUBLIC_URL}/data/AmsCenter.geojson`, // eslint-disable-line
  AMSTERDAM_TREES:
    `${process.env.PUBLIC_URL}/data/AmsTrees.json`, // eslint-disable-line
  BUENOS:
    `${process.env.PUBLIC_URL}/data/BueClean.json`, // eslint-disable-line
  BUENOS_CENTER:
    `${process.env.PUBLIC_URL}/data/BueCenter.geojson`, // eslint-disable-line
  BUENOS_TREES:
    `${process.env.PUBLIC_URL}/data/BueTrees.json`, // eslint-disable-line
  CAMBRIDGE:
    `${process.env.PUBLIC_URL}/data/CamClean.json`, // eslint-disable-line
  CAMBRIDGE_CENTER:
    `${process.env.PUBLIC_URL}/data/CamCenter.geojson`, // eslint-disable-line
  CAMBRIDGE_TREES:
    `${process.env.PUBLIC_URL}/data/CamTrees.json`, // eslint-disable-line
  MELBOURNE:
    `${process.env.PUBLIC_URL}/data/MelClean.json`, // eslint-disable-line
  MELBOURNE_CENTER:
    `${process.env.PUBLIC_URL}/data/MelCenter.geojson`, // eslint-disable-line
  MELBOURNE_TREES:
    `${process.env.PUBLIC_URL}/data/MelTrees.json`, // eslint-disable-line
  OSLO:
    `${process.env.PUBLIC_URL}/data/OslClean.json`, // eslint-disable-line
  OSLO_CENTER:
    `${process.env.PUBLIC_URL}/data/OslCenter.geojson`, // eslint-disable-line
  OSLO_TREES:
    `${process.env.PUBLIC_URL}/data/OslTrees.json`, // eslint-disable-line
  PARIS:
    `${process.env.PUBLIC_URL}/data/ParClean.json`, // eslint-disable-line
  PARIS_CENTER:
    `${process.env.PUBLIC_URL}/data/ParCenter.geojson`, // eslint-disable-line
  PARIS_TREES:
    `${process.env.PUBLIC_URL}/data/ParTrees.json`, // eslint-disable-line
  VANCOUVER:
    `${process.env.PUBLIC_URL}/data/VanClean.json`, // eslint-disable-line
  VANCOUVER_CENTER:
    `${process.env.PUBLIC_URL}/data/VanCenter.geojson`, // eslint-disable-line
  VANCOUVER_TREES:
    `${process.env.PUBLIC_URL}/data/VanTrees.json`, // eslint-disable-line
};

var PLANT_TAXONOMY = []
var PLANT_FAMILY = []

const customStyles = {
  control: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return { 
      ...styles, 
      background: 'none',
      border:'none',
      boxShadow: "none",
      height:"max-content",

      ":hover": {
        ...styles[':hover'],
        border:'none',
        boxShadow: "none"
      },
      ":focus": {
        ...styles[':focus'],
        border:'none',
        boxShadow: "none"
      }
    }
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      padding: 20,
      color: isSelected ? 'green' : 'white',
      background:"#242424",
      fontSize:'calc(10px+1vw)',
      border:"1px solid white",
      borderBottom:'1px dotted white',
      lineHeight:1.1,
      transition:'250ms all',

      ':active': {
        ...styles[':active'],
        backgroundColor: 'none',
      },
      ':hover': {
        ...styles[':hover'],
        color: '#bdffbf',
      },
    };
  },
  input: styles => (
    { ...styles,
      background:"none"
    }
  ),
  placeholder: styles => (
    { ...styles }
  ),
  menu: styles => {
    return { 
      ...styles,
      width:'max-content',
      transform:'translateY(-5px)'
    }
  },
  container: styles => ({
    ...styles,
    outline:'none',
    width:'max-content',
    pointerEvents:'auto'
  }),

  valueContainer: styles => ({
    background:"none",
    paddingBottom:'20px'
  }),
  
  menuList: styles => ({
    ...styles,
    background:'none',
    border:"none",
    overflow:'visible',
    height:'max-content'
  }),
  singleValue: styles => (
    {
      fontSize:'calc(1vw + 24px)', 
      color:"white", 
      background:"none",
      border:`none`,
      paddingBottom:`20px`,
      paddingRight:`20px`,
      transform:'translateY(30px)'
    }
  ),
};

const options = [
  { value: 'amsterdam', label: 'Amsterdam, Netherlands' },
  { value: 'bologna', label: 'Bologna, Italy' },
  { value: 'buenos', label: 'Buenos Aires, Argentina' },
  { value: 'cambridge', label: 'Cambridge, MA, USA' },
  { value: 'melbourne', label: 'Melbourne, Australia' },
  { value: 'oslo', label: 'Oslo, Norway' },
  { value: 'paris', label: 'Paris, France' },
  { value: 'vancouver', label: 'Vancouver, Canada' }
];

const cities = {
  'amsterdam': {
    longitude: 4.899,
    latitude: 52.365,
    zoom: 11,
    cityId: 0,
    name: "Amsterdam, Netherlands",
    data: {
      center: {
        speciesMostAbundant:46.8932443703082,
        genusMostAbundant:72.1675113876948,
        familyMostAbundant:72.2904148324282,
        speciesName:"Dutch Elm",
        speciesNameLatin:"Ulmus hollandica",
        genusName:"Elm Trees",
        genusNameLatin:"Ulmus",
        familyName:"Elms and Zelkovas",
        familyNameLatin:"Ulmaceae",
      },
      outside: {
        speciesMostAbundant:10.9558598207289,
        genusMostAbundant:18.6407332164019,
        familyMostAbundant:18.7192599561034,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus hispanica",
        genusName:"Elm Trees",
        genusNameLatin:"Ulmus",
        familyName:"Elms and Zelkovas",
        familyNameLatin:"Ulmaceae",
      }
    },
    bins: [0,.34,.54,.67,.81,1.02,1.23,1.58,2.8],
    topSpecies: ['Platanus hispanica', 'Tilia europaea', 'Ulmus hollandica', 'Fraxinus excelsior', 'Quercus robur']
  },
  'bologna':{
    latitude: 44.4947532,
    longitude: 11.342444,
    zoom: 11.5,
    cityId: 1,
    name: "Bologna, Italy",
    data: {
      center: {
        speciesMostAbundant:22.8662110799475,
        genusMostAbundant:23.054781159044,
        familyMostAbundant:23.5409778923668,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus acerifolia",
        genusName:"Plane Trees",
        genusNameLatin:"Platanus",
        familyName:"Plane Tree Family",
        familyNameLatin:"Platanaceae",
      },
      outside: {
        speciesMostAbundant:16.0110713583429,
        genusMostAbundant:16.011071358343,
        familyMostAbundant:16.115091148994,
        speciesName:"European Nettle Tree",
        speciesNameLatin:"Celtis australis",
        genusName:"Nettle Trees",
        genusNameLatin:"Celtis",
        familyName:"Hemp Plants",
        familyNameLatin:"Cannabaceae",
      }
    },
    bins: [0, .31,.58,.75,1.02,1.28,1.56,1.92,2.85],
    topSpecies:['Celtis australis','Platanus acerifolia','Tilia intermedia','Fraxinus excelsior','Acer campestre']
  },
  'buenos':{
    longitude: -58.389,
    latitude: -34.597,
    zoom: 10.75,
    cityId: 2,
    name: "Buenos Aires, Argentina",
    data: {
      center: {
        speciesMostAbundant:33.1236811154543,
        genusMostAbundant:33.1236811154541,
        familyMostAbundant:33.5990787959782,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus acerifolia",
        genusName:"Plane Trees",
        genusNameLatin:"Platanus",
        familyName:"Plane Tree Family",
        familyNameLatin:"Platanaceae",
      },
      outside: {
        speciesMostAbundant:32.2755257385098,
        genusMostAbundant:36.5903199249207,
        familyMostAbundant:39.1372746338076,
        speciesName:"Green Ash",
        speciesNameLatin:"Fraxinus pennsylvanica",
        genusName:"Ash Trees",
        genusNameLatin:"Fraxinus",
        familyName:"Olive Family",
        familyNameLatin:"Oleaceae",
      }
    },
    bins: [0, .62,.89,1.08,1.25,1.41,1.56,1.77,2.67],
    topSpecies: ['Fraxinus pennsylvanica','Platanus acerifolia','Ficus benjamina','Tilia moltkei','Melia azedarach']
  },
  'cambridge':{
    longitude: -71.119,
    latitude: 42.382,
    zoom: 12.6,
    cityId: 3,
    name: "Cambridge, Massachusetts",
    data: {
      center: {
        speciesMostAbundant:21.5859531287785,
        genusMostAbundant:30.5648779600498,
        familyMostAbundant:31.131211683527,
        speciesName:"Norway Maple",
        speciesNameLatin:"Acer platanoides",
        genusName:"Maple Trees",
        genusNameLatin:"Acer",
        familyName:"Soapberry Family",
        familyNameLatin:"Sapindaceae",
      },
      outside: {
        speciesMostAbundant:18.1191436656491,
        genusMostAbundant:26.2684191211015,
        familyMostAbundant:26.7386662738803,
        speciesName:"Norway Maple",
        speciesNameLatin:"Acer platanoides",
        genusName:"Maple Trees",
        genusNameLatin:"Acer",
        familyName:"Soapberry Family",
        familyNameLatin:"Sapindaceae",
      }
    },
    bins: [0, .34,.59,.7,.95,1.17,1.39,1.65,2.62],
    topSpecies:['Acer platanoides','Gleditsia triacanthos','Acer rubrum','Quercus palustris','Tilia cordata']
  },
  'melbourne':{
    longitude: 144.95,
    latitude: -37.813,
    zoom: 12,
    cityId: 4,
    name: "Melbourne, Austrailia",
    data: {
      center: {
        speciesMostAbundant:33.7958960996422,
        genusMostAbundant:41.2160430077706,
        familyMostAbundant:41.3416683802057,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus acerifolia",
        genusName:"Elm Trees",
        genusNameLatin:"Ulmus",
        familyName:"Elms and Zelkovas",
        familyNameLatin:"Ulmaceae",
      },
      outside: {
        speciesMostAbundant:19.51525453175,
        genusMostAbundant:37.9622213153544,
        familyMostAbundant:38.4888649498162,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus acerifolia",
        genusName:"Elm Trees",
        genusNameLatin:"Ulmus",
        familyName:"Elms and Zelkovas",
        familyNameLatin:"Ulmaceae",
      }
    },
    bins: [0,.13,.328,.507,.611,.682,.83,1.11,2.521],
    topSpecies:['Platanus acerifolia','Corymbia maculata','Ulmus unknown','Ulmus procera','Lophostemon confertus']
  },
  'oslo':{
    longitude: 10.725,
    latitude: 59.921,
    zoom: 11.25,
    cityId: 5,
    name: "Oslo, Norway",
    data: {
      center: {
        speciesMostAbundant:51.7485944387294,
        genusMostAbundant:52.9214343553906,
        familyMostAbundant:53.0312994813063,
        speciesName:"Linden Tree Species",
        speciesNameLatin:"Tilia Sp.",
        genusName:"Linden Trees",
        genusNameLatin:"Tilia",
        familyName:"Mallow Family",
        familyNameLatin:"Malvaceae",
      },
      outside: {
        speciesMostAbundant:17.3851226250284,
        genusMostAbundant:24.401304286052,
        familyMostAbundant:33.0216925697098,
        speciesName:"Norway Maple",
        speciesNameLatin:"Acer platanoides",
        genusName:"Maple Trees",
        genusNameLatin:"Acer",
        familyName:"Soapberry Family",
        familyNameLatin:"Sapindaceae",
      }
    },
    bins: [0,.259,.474,.591,.662,.724,.992,1.176,2.2123],
    topSpecies:['Tilia Sp.','Acer platanoides','Ulmus glabra','Tilia','Betula pendula']
  },
  'paris':{
    longitude: 2.343,
    latitude: 48.858,
    zoom: 11.5,
    cityId: 6,
    name: "Paris, France",
    data: {
      center: {
        speciesMostAbundant:41.6175877162174,
        genusMostAbundant:62.3851455352538,
        familyMostAbundant:62.41155936619,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus hispanica",
        genusName:"Plane Trees",
        genusNameLatin:"Platanus",
        familyName:"Plane Tree Family",
        familyNameLatin:"Platanaceae",
      },
      outside: {
        speciesMostAbundant:41.5376919544525,
        genusMostAbundant:45.1288604472228,
        familyMostAbundant:45.1404351991966,
        speciesName:"London Plane",
        speciesNameLatin:"Platanus hispanica",
        genusName:"Plane Trees",
        genusNameLatin:"Platanus",
        familyName:"Plane Tree Family",
        familyNameLatin:"Platanaceae",
      }
    },
    bins: [0,.087,.223,.401,.548,.655,.739,.998,2.524],
    topSpecies:['Platanus hispanica','Aesculus hippocastanum','Sophora japonica','Tilia tomentosa','Aesculus carnea']
  },
  'vancouver':{
    longitude: -123.124,
    latitude: 49.25,
    zoom: 11.5,
    cityId: 7,
    name: "Vancouver, British Columbia",
    data: {
      center: {
        speciesMostAbundant:19.5034356134065,
        genusMostAbundant:38.5569803756402,
        familyMostAbundant:39.0643572509952, 
        speciesName:"Red Maple",
        speciesNameLatin:"Acer rubrum",
        genusName:"Maple Trees",
        genusNameLatin:"Acer",
        familyName:"Soapberry Trees",
        familyNameLatin:"Sapindaceae",
      },
      outside: {
        speciesMostAbundant:17.5581413454681,
        genusMostAbundant:27.7204174782501,
        familyMostAbundant:29.8247072171091,
        speciesName:"Japanese Cherry",
        speciesNameLatin:"Prunus serrulata",
        genusName:"Plum and Cherry Trees",
        genusNameLatin:"Prunus",
        familyName:"Rose Family",
        familyNameLatin:"Rosaceae",
      }
    },
    bins: [0,.25,.47,.63,.73,.9,1.07,1.29,2.62],
    topSpecies: ['Prunus serrulata','Prunus cerasifera','Acer platanoides','Acer rubrum','Carpinus betulus']
  }
}

const INITIAL_VIEW_STATE = {
  longitude: cities["bologna"].longitude,
  latitude: cities["bologna"].latitude,
  zoom: cities["bologna"].zoom,
  pitch: 0,
  bearing: 0,
  maxZoom:15,
  minZoom:10
};

const speciesColorScale = d3.scaleLinear().domain([0,10,20,30,100])
  .range([d3.rgb("#006603"),d3.rgb("#006603"), d3.rgb("#bdffbf"), d3.rgb('#feada5'), d3.rgb('#fc1500')]);
const genusColorScale = d3.scaleLinear().domain([0,20,30,40,100])
.range([d3.rgb("#006603"),d3.rgb("#006603"), d3.rgb("#bdffbf"), d3.rgb('#feada5'), d3.rgb('#fc1500')]);
const familyColorScale = d3.scaleLinear().domain([0,30,40,50,100])
.range([d3.rgb("#006603"),d3.rgb("#006603"), d3.rgb("#bdffbf"), d3.rgb('#feada5'), d3.rgb('#fc1500')]);

function MultiColorScale(num, taxonomy){
  if (taxonomy === "species") {
    return speciesColorScale(num)
  } else if (taxonomy === "genus") {
    return genusColorScale(num)
  } else {
    return familyColorScale(num)
  }
}

const staticColorScale = ["#bdffbf","#a0e9a2","#88d38a","#6bbd6e","#51a954","#369139","#1c7d1f","#006603"]

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class HeroMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewState: INITIAL_VIEW_STATE,
      cityName: cities["bologna"].name,
      currCity: "bologna",
      mapType: 'blocks',
      data: cities["bologna"].data,
      bins: cities['bologna'].bins,
      topSpecies: cities['bologna'].topSpecies,
      networkData:{"nodes":[{"id":0}]},
      networkOpacity:0,
      selectedOption: 0,
      currTree: null
    };    
    
    this._onViewStateChange = this._onViewStateChange.bind(this);
  }
  _DrawDotLineGraphs = (taxonomy, insideOutside) => {
    let data = Object.values(cities);

    let currWidth = document.getElementById(`${taxonomy}Abundance${capitalize(insideOutside)}`).offsetWidth;

    let benchmarkValues = {
      "species":10,
      "genus":20,
      "family":30
    }

    var margin = {top: 10, right: 40, bottom: 10, left: 10},
      width = currWidth - margin.left - margin.right,
      height = 40 - margin.top - margin.bottom;

    var svg = d3.select(this.refs[`${taxonomy}Abundance${capitalize(insideOutside)}`])
        .html("")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")")

    // Add X axis
    var x = d3.scaleLinear()
      .domain([0, 75])
      .range([ 0, width ]);
    svg.append("g")
      .style("color","white")
      .call(d3.axisBottom(x).tickFormat(d => d + "%"));
      

    var div = d3.select("body").append("div")	
      .attr("class", "tooltip")			
      .style("opacity", 0);

    // Add dots
    svg.append('g')
    .selectAll("dot")
    .data(data)
    .enter()
    .append("circle")
      .attr("cx", function (d) { return x(d.data[`${insideOutside}`][`${taxonomy}MostAbundant`]); } )
      .attr("fill",function (d) { return MultiColorScale(d.data[`${insideOutside}`][`${taxonomy}MostAbundant`],taxonomy); } )
      .attr("id",function (d) { return `${insideOutside}${capitalize(taxonomy)}Dot${d.cityId}`; })
      .attr("r",d=>d.name===this.state.cityName?10:5)
      .attr("class","infoDot")
      .on("mouseover", function(d) {		
        div.transition()		
            .duration(200)		
            .style("opacity", .9);		
        div.html(`Most Abundant Species
                      </br>${d.name}
                      </br>${d.data[`${insideOutside}`][`${taxonomy}MostAbundant`].toFixed(2)}%`)	
            .style("left", (d3.event.pageX) + "px")		
            .style("top", (d3.event.pageY - 28) + "px");	
        })					
      .on("mouseout", function(d) {		
          div.transition()		
              .duration(500)		
              .style("opacity", 0);	
      })
    
      svg.append('g')
        .append("line")
        .attr("x1", x(benchmarkValues[`${taxonomy}`]) )
        .attr("x2", x(benchmarkValues[`${taxonomy}`]) )
        .attr("y1", 20)
        .attr("y2", 40)
        .attr("class","benchmarkLine")
        .attr("stroke-dasharray","4,2")
      
      svg.append('g')
        .append("text")
        .attr("x", x(benchmarkValues[`${taxonomy}`]+2) )
        .attr("y", 40)
        .text(`${taxonomy} benchmark`)
        .attr("class",`${taxonomy}`)
  }

  _DrawDotLineGraphsLegend = () => {

    let currWidth = document.getElementById(`dotLegend`).offsetWidth;

    var margin = {top: 40, right: 0, bottom: 20, left: 0},
      width = currWidth - margin.left - margin.right,
      height = 100 - margin.top - margin.bottom;

    var svg = d3.select(this.refs.dotLegend)
        .html("")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")")

    // Add X axis
    var x = d3.scaleLinear()
      .domain([0, 75])
      .range([ 0, width ]);
    // svg.append("g")
    //   .style("color","white")
    //   .call(d3.axisBottom(x).tickFormat(d => d + "%"));


    // Add dots
    svg.append('g')
      .append("circle")
      .attr("cx", x(10))
      .attr("fill", "white" )
      .attr("r", 10)
      .attr("class","infoDot")
    svg.append('g')  
      .append("circle")
      .attr("cx", x(15))
      .attr("fill", "white" )
      .attr("r", 5)
      .attr("class","infoDot")
    svg.append('g')  
      .append("circle")
      .attr("cx", x(17))
      .attr("fill", "white" )
      .attr("r", 5)
      .attr("class","infoDot")
    svg.append('g')  
      .append("circle")
      .attr("cx", x(20))
      .attr("fill", "white" )
      .attr("r", 5)
      .attr("class","infoDot")
    // Add Gradient
    var defs = svg.append("defs");

    var linearGradient = defs.append("linearGradient")
        .attr("id", "linear-gradient");
    
    linearGradient
      .attr("x1", "0%")
      .attr("y1", "0%")
      .attr("x2", "100%")
      .attr("y2", "0%");
    linearGradient.append("stop")
      .attr("offset", "0%")
      .attr("stop-color", "#006603"); //light blue

    linearGradient.append("stop")
      .attr("offset", "15%")
      .attr("stop-color", "#006603"); //light blue

    linearGradient.append("stop")
      .attr("offset", "30%")
      .attr("stop-color", "#bdffbf"); //light blue

    linearGradient.append("stop")
      .attr("offset", "75%")
      .attr("stop-color", "#feada5"); //light blue

    linearGradient.append("stop")
      .attr("offset", "100%")
      .attr("stop-color", "#fc1500"); //dark blue

    svg.append("rect")
      .attr("width", x(70)-x(30))
      .attr("height", 5)
      .attr("x",x(35))
      .attr("y",-2.5)
      .style("fill", "url(#linear-gradient)");

    // Add text
    svg.append('g')
      .append("text")
      .attr("x", x(10))
      .attr("y", -30)
      .attr("text-anchor","middle")
      .text(`current city`)
      .attr("class",`species`)
    svg.append('g')
      .append("text")
      .attr("x", x(18))
      .attr("text-anchor","middle")
      .attr("y", 25)
      .text(`other study cities`)
      .attr("class",`species`)
    svg.append('g')
      .append("text")
      .attr("x", x(35))
      .attr("y", -30)
      .text(`street trees meet benchmark`)
      .attr("class",`species`)
    svg.append('g')
      .append("text")
      .attr("x", x(50))
      .attr("y", 30)
      .attr("text-anchor","middle")
      .text(`close to benchmark`)
      .attr("class",`species`)
      
    svg.append('g')
      .append("text")
      .attr("x", x(75))
      .attr("text-anchor","end")
      .attr("y", -30)
      .text(`exceed benchmark`)
      .attr("class",`species`)
    // svg.append('g')
    //   .append("line")
    //   .attr("x1", x(benchmarkValues[`${taxonomy}`]) )
    //   .attr("x2", x(benchmarkValues[`${taxonomy}`]) )
    //   .attr("y1", 20)
    //   .attr("y2", 40)
    //   .attr("class","benchmarkLine")
    //   .attr("stroke-dasharray","4,2")
      

  }

  componentDidMount = () => {
    window.addEventListener('resize', this._handleResize)
    let taxonomies = ["species", "genus", "family"]
    taxonomies.forEach(taxa => {
      this._DrawDotLineGraphs(taxa, "center")
      this._DrawDotLineGraphs(taxa, "outside")
    })
    this._DrawDotLineGraphsLegend();
    
    d3.csv(`${process.env.PUBLIC_URL}/data/geojson/plantTaxonomy.csv`, function(data) { 
      PLANT_TAXONOMY.push(data) 
      PLANT_FAMILY.push(data.family)
    })
  }
  _handleResize = () => {
    let taxonomies = ["species", "genus", "family"]
    taxonomies.forEach(taxa => {
      this._DrawDotLineGraphs(taxa, "center")
      this._DrawDotLineGraphs(taxa, "outside")
    })
    this._DrawDotLineGraphsLegend();
  }

  _onViewStateChange({viewState}) {
    this.setState({viewState});
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    document.removeEventListener('contextmenu', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  _onLoad({header, loaderData, progress}) {
  }

  _onInitialized(gl) {
    if (!isWebGL2(gl)) {
      console.warn('GPU aggregation is not supported'); // eslint-disable-line
      if (this.props.disableGPUAggregation) {
        this.props.disableGPUAggregation();
      }
    }
  }
  _handleNetworkGraphClick(){
    if (this.state.networkOpacity===0){
      this.setState({
        networkOpacity:1,
        currTree: null
      })
    } else {
      this.setState({
        networkOpacity:0,
        currTree: null
      })
    }
  }

  _handleTreeBlocks(mapType, city){
    this.setState({
      mapType: mapType,
      viewState: {
        ...this.state.viewState,
        pitch: (mapType==="trees"?45:0),
        transitionInterpolator: new FlyToInterpolator(),
        transitionDuration: 250,
      }, 
      currTree:null,
    })
  }
  
  _handleSpeciesButton(species){
    this.setState({
      currTree: species,
    })
  }

  resetNetworkData = () => {
    let node = document.getElementsByClassName("taxonomyContainer")[0].children[0].children[1].children

    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  parseHexData(speciesList){
    // if (this.state.hoveredObject != undefined) {
    this.resetNetworkData()

    let cleanSpecies = speciesList.split(',')
    
    var networkData = {};

    var species = [];
      
    cleanSpecies.forEach(function(elem){
      elem = elem.replace(" '","").replace("'","")
      species.push({
        'name':elem,
        'parent':elem.split(' ')[0]
      })
    })
    species.forEach(function(speciesEntry){
      let genusName = speciesEntry.parent
      let taxaGenera = PLANT_TAXONOMY[_.findLastIndex(PLANT_TAXONOMY, ['genus', genusName])];

      try {

        if (networkData.name === undefined) {
          networkData.name = taxaGenera.kingdom;
          networkData.children = [];
        }

        if(networkData.children.findIndex((element) => element.name === taxaGenera.phylum) === -1) {
          networkData.children.push({name: taxaGenera.phylum, children: []});
        }

        let tempClassIndex = networkData.children.findIndex((element) => element.name === taxaGenera.phylum);
        let tempClass = networkData.children[tempClassIndex]
        if((tempClass.children.length===0) || (tempClass.children.findIndex((element) => element.name === taxaGenera.class) === -1)) {
          tempClass.children.push({name: taxaGenera.class, children: []});
        }

        let tempOrderIndex = tempClass.children.findIndex((element) => element.name === taxaGenera.class);
        let tempOrder = tempClass.children[tempOrderIndex]
        if((tempOrder.children.length===0) || (tempOrder.children.findIndex((element) => element.name === taxaGenera.order) === -1)) {
          tempOrder.children.push({name: taxaGenera.order, children: []});
        }

        let tempFamilyIndex = tempOrder.children.findIndex((element) => element.name === taxaGenera.order);
        let tempFamily = tempOrder.children[tempFamilyIndex]
        if((tempFamily.children.length===0) || (tempFamily.children.findIndex((element) => element.name === taxaGenera.family) === -1)) {
          tempFamily.children.push({name: taxaGenera.family, children: []});
        }

        let tempGenusIndex = tempFamily.children.findIndex((element) => element.name === taxaGenera.family);
        let tempGenus = tempFamily.children[tempGenusIndex]
        if((tempGenus.children.length===0) || (tempGenus.children.findIndex((element) => element.name === taxaGenera.genus) === -1)) {
          tempGenus.children.push({name: taxaGenera.genus, children: []});
        }

        let tempSpeciesIndex = tempGenus.children.findIndex((element) => element.name === taxaGenera.genus);
        let tempSpecies = tempGenus.children[tempSpeciesIndex]
        if((tempSpecies.children.length===0) || (tempSpecies.children.findIndex((element) => element.name === speciesEntry) === -1)) {
          tempSpecies.children.push({name: speciesEntry.name});
        }
      } catch {
      }      
    });
    this.setState({
      networkData: networkData
    })
    // }
  };

  // setTooltip(info){
  //   if (info.picked){
  //     this.setState({
  //       hoveredObject: info.object,
  //       pointerX: info.x,
  //       pointerY: info.y
  //     })
  //   } else {
  //     this.setState({
  //       pointerX: -5000,
  //       pointerY: -5000
  //     })
  //   };

  //   this.parseHexData()
  // };
  

  _ColorScale(bins, val) {
    let tempColorScale = d3.scaleLinear()
      .domain(bins)
      .range([[189,255,191],[0,102,3]]);
    return tempColorScale(val)
  }

  _getRand(scale){
    return Math.random()*scale|0
  }

  _setTree = (tree) => {
    this.setState({
      currTree:tree
    })
  }

  _renderLayers(cityName, mapType) {
    const {data = DATA_URL} = this.props;

    let layers = {
      'amsterdam': {
        'blocks': [      
          new PolygonLayer({
            id: 'ams blocks',
            opacity:1,
            data: data.AMSTERDAM,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'ams center',
            data: data.AMSTERDAM_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'ams center',
            data: data.AMSTERDAM_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'AMS trees',
            data: data.AMSTERDAM_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'bologna':{
        'blocks': [
          new PolygonLayer({
            id: 'bologna blocks',
            opacity:1,
            data: data.BOLOGNA,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'bol center',
            data: data.BOLOGNA_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'bol center',
            data: data.BOLOGNA_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'bol trees',
            data: data.BOLOGNA_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'buenos':{
        'blocks': [
          new PolygonLayer({
            id: 'buenos blocks',
            opacity:1,
            data: data.BUENOS,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'BUENOS',
            data: data.BUENOS_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'BUENOS',
            data: data.BUENOS_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'bue trees',
            data: data.BUENOS_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'cambridge':{
        'blocks': [
          new PolygonLayer({
            id: 'cambridge blocks',
            opacity:1,
            data: data.CAMBRIDGE,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'cam center',
            data: data.CAMBRIDGE_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'cam center',
            data: data.CAMBRIDGE_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'CAM trees',
            data: data.CAMBRIDGE_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'melbourne':{
        'blocks': [
          new PolygonLayer({
            id: 'melbourne blocks',
            opacity:1,
            data: data.MELBOURNE,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'mel center',
            data: data.MELBOURNE_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'mel center',
            data: data.MELBOURNE_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'MEL trees',
            data: data.MELBOURNE_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'oslo':{
        'blocks': [
          new PolygonLayer({
            id: 'oslo blocks',
            opacity:1,
            data: data.OSLO,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'oslo center',
            data: data.OSLO_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'oslo center',
            data: data.OSLO_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'OSL trees',
            data: data.OSLO_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'paris':{
        'blocks': [
          new PolygonLayer({
            id: 'paris blocks',
            opacity:1,
            data: data.PARIS,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'paris center',
            data: data.PARIS_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'paris center',
            data: data.PARIS_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'PAR trees',
            data: data.PARIS_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      },
      'vancouver':{
        'blocks': [
          new PolygonLayer({
            id: 'vancouver blocks',
            opacity:1,
            data: data.VANCOUVER,
            pickable: true,
            stroked: false,
            extruded:false,
            wireframe:true,
            filled: true,
            autoHighlight: true,
            lineWidthMinPixels: 1,
            getPolygon: d => d[0],
            getElevation: d => d[10]*100,
            getFillColor: d => this._ColorScale([0,0.92],d[10]),
            onClick: info => {try { this.parseHexData(info.object[1])} catch {}}
          }),
          new GeoJsonLayer({
            id: 'vancouver center',
            data: data.VANCOUVER_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          })
        ],
        'trees': [
          new GeoJsonLayer({
            id: 'vancouver center',
            data: data.VANCOUVER_CENTER,
            opacity: 1,
            stroked: true,
            filled: false,
            wireframe: false,
            getFillColor: [0,0,0,0],
            getLineColor: [255,255,255],
            lineWidthScale: 20,
            lineWidthMinPixels: 5,
            pickable: true
          }),
          new SimpleMeshLayer({
            id: 'VAN trees',
            data: data.VANCOUVER_TREES,
            getPosition: d=>d[0],
            sizeScale: 2,
            opacity: 1,
            pickable:true,
            getScale: d => [Math.sqrt(d[1])/2,Math.sqrt(d[1])/2,Math.sqrt(d[1])*2],
            mesh: sphere,
            // wireframe:true,
            getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            // getOrientation: d => [0,parseInt((""+d[0][0]).slice(-3,))%365,90],
            getTranslation: d => [0,0,Math.sqrt(d[1])+2],
            // texture:`${process.env.PUBLIC_URL}/noise.png`,
            updateTriggers: {
              getColor: d => (this.state.currTree!==null && this.state.currTree!==d[2]?[50,50,50,1]:[50,100,50,255]),
            }
          })
        ]
      }
    }

    let tempLayers = []
    tempLayers.push(layers[cityName][mapType])

    return tempLayers
  }

  HandleNavControl = (viewState) => {
    if (viewState.zoom>15) {
      viewState.zoom=15
    } else if (viewState.zoom<10) {
      viewState.zoom=10
    }

    this.setState({
      viewState
    })
  }
  _changeCity = selectedOption => {

    this.setState({
      pointerX: -5000,
      pointerY: -5000,
      networkOpacity:0,
      CurrCity: selectedOption.value,
      currTree: null,
      mapType:"blocks"
    })

    let city = selectedOption.value

    d3.selectAll(".infoDot").attr("r", "5");
    
    let taxonomies = ["Species","Genus","Family"]
    
    taxonomies.forEach(taxa => {
      d3.select(`#center${taxa}Dot${cities[city].cityId}`)
        .transition()
        .delay(500)
        .attr('r',"10");
      d3.select(`#outside${taxa}Dot${cities[city].cityId}`)
        .transition()
        .delay(500)
        .attr('r',"10");
    })

    this.setState({
      viewState: {
        ...this.state.viewState,
        longitude: cities[city].longitude,
        latitude: cities[city].latitude,
        zoom: cities[city].zoom,
        pitch: 0,
        bearing: 0,
        transitionDuration: 0
      }, 
      cityName: cities[city].name,
      currCity: city,
      data: cities[city].data,
      topSpecies: cities[city].topSpecies
    })
  };

  render() {
    const {viewState} = this.state;
    return (
    <VizContainer className="vizContainer">      
      <CityInfo>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
          <p className="tooltip">select a city</p>
          <Select 
              defaultValue={options[1]}
              styles={customStyles}
              onChange={this._changeCity.bind(this)}
              options={options}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <div id="dotLegend" ref="dotLegend"></div>
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} lg={4} id="City Center">
              <p className="tooltip"><b>city center</b> most abundant organisms</p>
              <h4>Species</h4>
              <h5><i>{this.state.data['center'].speciesName}</i></h5>
              <h5><i>{this.state.data['center'].speciesNameLatin}</i></h5>
              <h2 style={{color:speciesColorScale(this.state.data['center'].speciesMostAbundant)}}>{(this.state.data['center'].speciesMostAbundant).toFixed(2)}%</h2>
              <div ref="speciesAbundanceCenter" id="speciesAbundanceCenter"></div>
          </Grid>
          <Grid item xs={12} lg={4}>
            <p className="tooltip">&nbsp;</p>
            <h4>Genus</h4>
            <h5><i>{this.state.data['center'].genusName}</i></h5>
            <h5><i>{this.state.data['center'].genusNameLatin}</i></h5>
            <h2 style={{color:genusColorScale(this.state.data['center'].genusMostAbundant)}}>{(this.state.data['center'].genusMostAbundant).toFixed(2)}%</h2>
            <div ref="genusAbundanceCenter" id="genusAbundanceCenter"></div>
          </Grid>
          <Grid item xs={12} lg={4}>
            <p className="tooltip">&nbsp;</p>
            <h4>Family</h4>
            <h5><i>{this.state.data['center'].familyName}</i></h5>
            <h5><i>{this.state.data['center'].familyNameLatin}</i></h5>
            <h2 style={{color:familyColorScale(this.state.data['center'].familyMostAbundant)}}>{(this.state.data['center'].familyMostAbundant).toFixed(2)}%</h2>
            <div ref="familyAbundanceCenter" id="familyAbundanceCenter"></div>
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} lg={4} id="City Center">
              <p className="tooltip"><b>outside</b> city center</p>
              <h4>Species</h4>
              <h5><i>{this.state.data['outside'].speciesName}</i></h5>
              <h5><i>{this.state.data['outside'].speciesNameLatin}</i></h5>
              <h2 style={{color:speciesColorScale(this.state.data['outside'].speciesMostAbundant)}}>{(this.state.data['outside'].speciesMostAbundant).toFixed(2)}%</h2>
              <div ref="speciesAbundanceOutside" id="speciesAbundanceOutside"></div>
          </Grid>
          <Grid item xs={12} lg={4}>
            <p className="tooltip">&nbsp;</p>
            <h4>Genus</h4>
            <h5><i>{this.state.data['outside'].genusName}</i></h5>
            <h5><i>{this.state.data['outside'].genusNameLatin}</i></h5>
            <h2 style={{color:genusColorScale(this.state.data['outside'].genusMostAbundant)}}>{(this.state.data['outside'].genusMostAbundant).toFixed(2)}%</h2>
            <div ref="genusAbundanceOutside" id="genusAbundanceOutside"></div>
          </Grid>
          <Grid item xs={12} lg={4}>
            <p className="tooltip">&nbsp;</p>
            <h4>Family</h4>
            <h5><i>{this.state.data['outside'].familyName}</i></h5>
            <h5><i>{this.state.data['outside'].familyNameLatin}</i></h5>
            <h2 style={{color:familyColorScale(this.state.data['outside'].familyMostAbundant)}}>{(this.state.data['outside'].familyMostAbundant).toFixed(2)}%</h2>
            <div ref="familyAbundanceOutside" id="familyAbundanceOutside"></div>
          </Grid>
        </Grid>
      </CityInfo>
      <MapContainer className="mapContainer">
        <DeckGL
          layers={this._renderLayers(this.state.currCity, this.state.mapType)}
          effects={this._effects}
          viewState={viewState}
          parameters={WEBGL_PARAMETERS}
          controller={{type: MapController, dragRotate: false, dragPan:true, doubleClickZoom:true, touchZoom: false, touchRotate:false, keyboard:false, scrollZoom: false}}
          onWebGLInitialized={this._onInitialized.bind(this)}
          onViewStateChange={this._onViewStateChange}
        >
          {/* { this._renderTooltip() } */}
          <MapGL
            reuseMaps
            mapStyle={mapStyle}
            preventStyleDiffing={true}
            mapboxApiAccessToken={MAPBOX_TOKEN}
          >
            <div className='mapboxgl-ctrl-bottom-left' style={{transform:"translateY(-40px)"}}>
              <NavigationControl 
                onViewportChange={viewState  => this.HandleNavControl(viewState)} />
            </div>
          </MapGL>
        </DeckGL>
        <RightCol style={{pointerEvents:"none"}}>
          
    <Button onClick={this._handleNetworkGraphClick.bind(this)} className={"networkButton"} style={{pointerEvents:"all"}}>{this.state.networkOpacity===0?(this.state.mapType==="blocks"?"Species Taxonomy":"Top Species"):"×"}</Button>
        <SpeciesForce style={{opacity: this.state.networkOpacity}} className="taxonomyContainer">
          <div style={{display: (this.state.mapType==="blocks"?"initial":"none")}}>
            <p>Species Taxonomy</p>
              <Tree
                data={this.state.networkData}
                className={"speciesMap"}
                height={forceHeight()}
                width={forceWidth()-30}
                style={{display:(this.state.networkData===null?"none":"initial")}}
                animated
                />
          </div>
          <div style={{display: (this.state.mapType==="trees"?"initial":"none"), pointerEvents:'all'}} className="speciesButtonContainer">
            <p>Top Tree Species</p>
              <Button onClick={() => this._handleSpeciesButton(1)} className={(this.state.currTree===1?"active":"")}><span>1</span> {this.state.topSpecies[0]}</Button>
              <Button onClick={() => this._handleSpeciesButton(2)} className={(this.state.currTree===2?"active":"")}><span>2</span> {this.state.topSpecies[1]}</Button>
              <Button onClick={() => this._handleSpeciesButton(3)} className={(this.state.currTree===3?"active":"")}><span>3</span> {this.state.topSpecies[2]}</Button>
              <Button onClick={() => this._handleSpeciesButton(4)} className={(this.state.currTree===4?"active":"")}><span>4</span> {this.state.topSpecies[3]}</Button>
              <Button onClick={() => this._handleSpeciesButton(5)} className={(this.state.currTree===5?"active":"")}><span>5</span> {this.state.topSpecies[4]}</Button>
          </div>
        </SpeciesForce>
      </RightCol>
      <LegendBox style={{display: (this.state.mapType!=="trees"?"initial":"none"), pointerEvents:'none'}}>
        <h1>Species Diversity (Shannon Index)</h1>
        <div style={{background:staticColorScale[0]}}></div>
        <div style={{background:staticColorScale[1]}}></div>
        <div style={{background:staticColorScale[2]}}></div>
        <div style={{background:staticColorScale[3]}}></div>
        <div style={{background:staticColorScale[4]}}></div>
        <div style={{background:staticColorScale[5]}}></div>
        <div style={{background:staticColorScale[6]}}></div>
        <div style={{background:staticColorScale[7]}}></div>
        {/* <p>{this.state.bins[0]}</p>
        <p>{this.state.bins[2]}</p>
        <p>{this.state.bins[4]}</p>
        <p>{this.state.bins[6]}</p>
        <p>{this.state.bins[8]}</p> */}
        <h2>Least Diverse</h2>
        <h2>Most Diverse</h2>
      </LegendBox>
      <TreeBlocksButtonContainer variant="contained" size="large" color="primary" orientation="vertical" aria-label="large primary button group">
        <TreeBlocksButton className={(this.state.mapType==="blocks"?'active TreeBlocksButton':'TreeBlocksButton')} onClick={() => this._handleTreeBlocks('blocks', this.state.currCity)}>Blocks</TreeBlocksButton>
        <TreeBlocksButton className={(this.state.mapType==="trees"?'active TreeBlocksButton':'TreeBlocksButton')} onClick={() => this._handleTreeBlocks('trees', this.state.currCity)}>Trees</TreeBlocksButton>
      </TreeBlocksButtonContainer>
      </MapContainer>
    </VizContainer>
    )
  }
}

let mapStateToProps = state => {
  return {
    screenWidth: state.screenWidth,
    screenHeight: state.screenHeight,
    tripsOpacity: state.tripsOpacity
  }
}

export default connect(mapStateToProps)(HeroMap);